import { GreeterEvent } from "@greeter/core";
import {
  Day,
  isNewYearsEve,
  isWithinMidnightPeriod,
  newYearsPeriod,
} from "@greeter/date";
import { upsert } from "@greeter/map";
import { addDays, differenceInDays, getDaysInMonth, subDays } from "date-fns";

export function groupDatesByWeekday(dates: Array<Date>): Map<Day, Array<Date>> {
  const m = new Map<Day, Array<Date>>();
  for (let i = 0, l = dates.length; i < l; i++) {
    const date = dates[i];
    if (isNewYearsEve(date)) {
      upsert(m, newYearsPeriod.from.getDay(), date);
    } else {
      upsert(m, date.getDay(), date);
    }
  }
  return m;
}

export function datesForMonth(monthDate: Date) {
  const month: Array<Date> = [];
  for (let i = 1, l = getDaysInMonth(monthDate); i <= l; i++) {
    month.push(new Date(monthDate.getFullYear(), monthDate.getMonth(), i));
  }
  return month;
}

const dateOnlyFormatter = Intl.DateTimeFormat("da-DK", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
});

export function indexEventsByDate(
  events: Array<GreeterEvent>
): Map<string, GreeterEvent> {
  const m = new Map<string, GreeterEvent>();

  for (let i = 0, l = events.length; i < l; i++) {
    const event = events[i];
    // We reset to midnight so we get dates where the it is only "half a days" difference.
    // For example 25/10/2025 20:00 26/10/2025 19:00 would not count as 1 day, even though
    //
    // Disabled for now, since it's awkward and we should check for openinghours
    // here
    //
    // const daysDiff = differenceInDays(
    //   set(event.endsAt, {
    //     hours: 0,
    //     minutes: 0,
    //     seconds: 0,
    //     milliseconds: 0,
    //   }),
    //   set(event.startsAt, {
    //     hours: 0,
    //     minutes: 0,
    //     seconds: 0,
    //     milliseconds: 0,
    //   })
    // );
    // const endsAt = isWithinMidnightPeriod(event.startsAt)
    //   ? subDays(event.endsAt, 1)
    //   : event.endsAt;
    const endsAt = event.endsAt;
    // const startsAt = isWithinMidnightPeriod(event.startsAt)
    //   ? subDays(event.startsAt, 1)
    //   : event.startsAt;
    const startsAt = event.startsAt;
    const daysDiff = differenceInDays(endsAt, startsAt);

    for (let j = 0; j <= daysDiff; j++) {
      m.set(dateOnlyFormatter.format(addDays(startsAt, j)), event);
    }
  }

  return m;
}

export function lookupEvent(
  m: Map<string, GreeterEvent>,
  d?: Date
): GreeterEvent | undefined {
  if (!d) {
    return undefined;
  }
  return m.get(dateOnlyFormatter.format(d));
}
